// client/src/utils/emailCanonicalize.js
export function canonicalizeEmail(input) {
  if (!input) return input;
  const trimmed = String(input).trim();

  const atIdx = trimmed.lastIndexOf('@');
  if (atIdx === -1) return trimmed; // pas d'@
  let local = trimmed.slice(0, atIdx);
  let domain = trimmed.slice(atIdx + 1).toLowerCase();

  // Unifie googlemail.com -> gmail.com
  if (domain === 'googlemail.com') domain = 'gmail.com';

  // Applique la normalisation SEULEMENT pour Gmail
  if (domain === 'gmail.com') {
    // Gmail ignore les points et le +tag dans la partie locale
    local = local.split('+')[0].replace(/\./g, '').toLowerCase();
    return `${local}@${domain}`;
  }

  // Pour les autres domaines: on garde tel quel, juste domain en lowercase
  return `${local}@${domain}`;
}
